import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"current\" viewBox=\"0 0 20 22\" id=\"icon-warning\"><path fill=\"#FA8C16\" fill-rule=\"evenodd\" d=\"M10 4.292a7.708 7.708 0 1 0 0 15.417 7.708 7.708 0 0 0 0-15.417M1.042 12a8.958 8.958 0 1 1 17.916 0 8.958 8.958 0 0 1-17.916 0M10 7.21c.345 0 .625.28.625.625v5a.625.625 0 0 1-1.25 0v-5c0-.346.28-.625.625-.625M8.958 15.75a1.042 1.042 0 1 1 2.083 0 1.042 1.042 0 0 1-2.083 0\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol